<template>
    <div>
      <div class="loading loadsmall" v-if="loadType === 'small'">
        <img width="24" height="24" src="https://cdncos.aigupiao.com/assets/app/h5/user_home/loading.gif">
        <p class="desc">{{title}}</p>
      </div>
      <div class="loading loadglobal" id="loading" v-if="loadType === 'global'">
        <div><i></i></div>
      </div>
    </div>
  </template>
  <script>
    export default {
      props: {
        title: {
          type: String,
          default: '正在载入...'
        },
        loadType: {
          type: String,
          default: 'global'
        }
      }
    }
  </script>
  <style scoped lang="scss">
  @import "~@/assets/sass/global.scss";
    .loadsmall{
      width: 100%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      .desc{
        line-height: rem2(20px);
        font-size: rem2(12px);
        margin-left: rem2(12px);
        color: #666;
      }
    }
    .loadglobal {
      position: fixed;
      z-index: 10003;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.8);
      i {
          position: absolute;
          top: rem2(20px); // 50%
          left: 50%;
          width: rem2(30px);
          height: rem2(30px);
          margin-left: rem2(-16px);
          -webkit-border-radius: rem2(100px);
          border-radius: rem2(100px);
          border: rem2(2px) solid #449BF7;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          border-top-color: rgba(51, 51, 51, 0);
          -webkit-animation: my_fhload .8s infinite linear;
          animation: my_fhload .8s infinite linear
      }
      >div {
          position: absolute;
          overflow: hidden;
          z-index: 1;
          left: 50%;
          top: 40%;
          -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          width: rem2(85px);
          min-height: rem2(85px);
          text-align: center;
          overflow: hidden;
          -webkit-display: -webkit-box;
          -webkit-display: -webkit-flex;
          display: -webkit-box;
          display: flex;
          -webkit-flex-wrap: wrap;
          flex-wrap: wrap;
          -webkit-align-content: center;
          align-content: center;
      }
      >div:after {
          content: "请稍后";
          display: block;
          margin-top: rem2(64px);
          min-width: 100%;
          color: #eee;
          text-align: center;
          white-space: pre-wrap;
          font-size: rem2(10px) !important;
          line-height: 1.3
      }
      @keyframes my_fhload {
          0% {
              transform: rotate(0);
              -webkit-transform: rotate(0);
          }
          100% {
              transform: rotate(360deg);
              -webkit-transform: rotate(360deg);
          }
      }
      @-webkit-keyframes my_fhload {
          0% {
              transform: rotate(0);
              -webkit-transform: rotate(0);
          }
          100% {
              transform: rotate(360deg);
              -webkit-transform: rotate(360deg);
          }
      }
    }
  </style>
  